import React from 'react'
import ProfileUpdate from '../Components/Profile Update/ProfileUpdate'

const ProfileUpdatePage = () => {
  return (
   <ProfileUpdate />
  )
}

export default ProfileUpdatePage